import { faCheck, faTimes, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router";
import swal from "sweetalert";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import CustomLoader from "../../customLoader/CustomLoader";
import "./MaintainGroup.css";

const MaintainGroup = () => {
  let location = useLocation();
  const [maintainGroupData, setMaintainGroupData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupDataFromService, setSelectedGroupDataFromService] =
    useState([]);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(null);
  const [openCreateGroup, setOpenCreateGroup] = useState(
    Boolean(location?.state?.openGroupMessage)
  );
  const [page] = useState(1);
  const [groupName, setGroupName] = useState("");
  const [user] = useState(
    localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : []
  );
  const [
    showLoaderWhileAddingStudentIntoList,
    setShowLoaderWhileAddingStudentIntoList,
  ] = useState(false);
  const [createGroupData, setCreateGroupData] = useState(null);
  const [openAddStudentContainer, setOpenAddStudentContainer] = useState(false);
  const [studentName, setStudentName] = useState("");
  const [showStudentContainer, setShowStudentContainer] = useState(false);
  const [showStudentList, setShowStudentList] = useState([]);
  const [showAddedStudentInGroup, setShowAddedStudentInGroup] = useState(false);
  const [studentListAfterAddedInGroup, setStudentListAfterAddedInGroup] =
    useState();
  const [creatingGroup, setCreatingGroup] = useState(false);
  const studentInputRef = useRef(null);
  const timeout = useRef();
  const [loading, setLoading] = useState(false);

  const getMaintainGroupData = () => {
    let obj = {
      school: user?.school_id,
      counselor: user?.counselor_id,
      page: page,
    };
    GetStudentService.getMaintainGroupData(obj)
      .then((data) => {
        setMaintainGroupData(data.data);
      })
      .catch(() => { });
  };

  const showSelectedGroupData = (item, index) => {
    setLoading(true);
    if (item?.dynamic === false) {
      setOpenCreateGroup(true);
      setOpenAddStudentContainer(true);
      setCreateGroupData(item);
      setShowAddedStudentInGroup(true);
    } else if (item?.dynamic === true) {
      setOpenCreateGroup(false);
      setOpenAddStudentContainer(false);
      setCreateGroupData(null);
      setShowAddedStudentInGroup(false);
    }
    setSelectedGroupDataFromService([]);
    setSelectedGroup(item);
    setSelectedGroupIndex(index);
    setStudentName("");
    setGroupName("");
    if (studentInputRef.current) {
      studentInputRef.current.value = "";
      setShowStudentContainer(false);
    }

    GetStudentService.getSelectedGroupData(item?.id)
      .then((data) => {
        setSelectedGroupDataFromService(data.data);
        if (item?.dynamic === false) {
          setStudentListAfterAddedInGroup(data.data);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const openCreateGroupHandler = () => {
    setOpenCreateGroup(true);
    setOpenAddStudentContainer(false);
    setCreateGroupData(null);
    setSelectedGroup(null);
    setSelectedGroupIndex(null);
    setSelectedGroupDataFromService([]);
    setStudentListAfterAddedInGroup();
    setShowAddedStudentInGroup(false);
    setShowStudentContainer(false);
    setShowStudentList([]);
    setStudentName("");
    setGroupName("");
    if (studentInputRef.current) studentInputRef.current.value = "";
  };

  const closeCreateGroupHandler = () => {
    setOpenCreateGroup(false);
    setOpenAddStudentContainer(false);
    setCreateGroupData(null);
    setGroupName("");
    setShowAddedStudentInGroup(false);
    setStudentListAfterAddedInGroup();
    setShowStudentContainer(false);
    setShowStudentList([]);
    setStudentName("");
  };

  const createGroupHandler = () => {
    const trimmedName = (groupName || "").trim();
    if (!trimmedName) {
      swal({
        text: "Please enter a group name.",
        icon: "warning",
        buttons: { confirm: "OK" },
        closeOnClickOutside: false,
      });
      return;
    }

    let obj = {
      id: "null",
      counselor: user?.counselor_id,
      name: trimmedName,
      school_id: user?.school_id,
    };
    setCreatingGroup(true);
    GetStudentService.createGroup(obj)
      .then((data) => {
        const created = data?.data?.objects || data?.data;
        setCreateGroupData(created);
        setOpenAddStudentContainer(true);
        setShowAddedStudentInGroup(true);
        setStudentListAfterAddedInGroup(created);
        setGroupName("");
        getMaintainGroupData();
        swal({
          title: "Created",
          text: data?.data?.message || "Group created successfully!",
          icon: "success",
          buttons: { confirm: "OK" },
          closeOnClickOutside: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status == 400 && error?.response?.data?.error) {
          swal({
            text: error?.response?.data?.error,
            icon: "warning",
            buttons: { confirm: "OK" },
            closeOnClickOutside: false,
          }).then(() => {
            setGroupName("");
          });
        } else {
          swal({
            text: "Unable to create group. Please try again.",
            icon: "warning",
            buttons: { confirm: "OK" },
            closeOnClickOutside: false,
          });
        }
      })
      .finally(() => setCreatingGroup(false));
  };

  const deleteGroup = (value) => {
    swal({
      text: `Are you sure that you want to delete ${value?.name} group?`,
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: "No",
        confirm: "Yes",
      },
      closeOnClickOutside: true,
    }).then((res) => {
      if (res) {
        deleteGroupService(value);
      }
    });
  };

  const deleteStudentHandler = (student) => {
    swal({
      text: `Are you sure that you want to delete the student ${student?.name}?`,
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: "No",
        confirm: "Yes",
      },
      closeOnClickOutside: true,
    }).then((value) => {
      if (value) {
        deleteStudent(student);
      }
    });
  };

  const getStudentData = (value) => {
    let body = {
      color: null,
      counselor: user?.counselor_id,
      page: page,
      school: user?.school_id,
      student_search: value,
      page_back: false,
      goal_id: 45,
    };
    GetStudentService.getStudentForMaintainGroup(body)
      .then((data) => {
        setShowStudentList(data?.data?.result || []);
        setShowStudentContainer(true);
      })
      .catch(() => { });
  };

  const handleStudentChange = (e) => {
    clearTimeout(timeout.current);
    const inputValue = e.target.value;
    if (!inputValue) {
      setShowStudentContainer(false);
      setShowStudentList([]);
      setStudentName("");
    } else {
      setStudentName(inputValue);
      timeout.current = setTimeout(() => {
        getStudentData(inputValue);
      }, 1000);
      setShowStudentContainer(true);
    }
  };

  const selectStudentFromListHandler = async (value) => {
    try {
      setShowLoaderWhileAddingStudentIntoList(true);
      let body = {
        group_id: createGroupData?.id,
        student_id: value?.id,
      };

      const addStudentResponse = await GetStudentService.addStudentInGroup(body);

      if (addStudentResponse.status === 200) {
        try {
          const groupDataResponse =
            await GetStudentService.getSelectedGroupData(createGroupData?.id);
          setShowStudentContainer(false);
          setShowStudentList([]);
          setShowAddedStudentInGroup(true);
          setStudentListAfterAddedInGroup(groupDataResponse.data);
          setShowLoaderWhileAddingStudentIntoList(false);
          if (studentInputRef.current) studentInputRef.current.value = "";
          setStudentName("");
        } catch (error) {
          setShowLoaderWhileAddingStudentIntoList(false);
          if (error?.response?.status === 400 && error?.response?.data?.error) {
            swal({
              text: error?.response?.data?.error,
              icon: "warning",
              buttons: { confirm: "OK" },
              closeOnClickOutside: false,
            });
          }
        }
      }
    } catch (error) {
      setShowLoaderWhileAddingStudentIntoList(false);
      if (error?.response?.status === 400) {
        swal({
          text: "Student already exists in the group.",
          icon: "warning",
          buttons: { confirm: "OK" },
          closeOnClickOutside: false,
        }).then(() => {
          setStudentName("");
          setShowStudentContainer(false);
        });
      }
    }
  };

  const deleteGroupService = (value) => {
    let obj = {
      group_id: value?.id,
    };
    GetStudentService.deleteGroup(obj)
      .then(() => {
        getMaintainGroupData();
        setOpenAddStudentContainer(false);
        setOpenCreateGroup(false);
        setSelectedGroup(null);
        setSelectedGroupIndex(null);
        setSelectedGroupDataFromService([]);
        setStudentListAfterAddedInGroup([]);
        setCreateGroupData(null);
        setShowAddedStudentInGroup(false);
        swal({
          title: "Deleted",
          text: "Group deleted successfully!",
          icon: "success",
          buttons: { confirm: "OK" },
          closeOnClickOutside: false,
        });
      })
      .catch(() => { });
  };

  const deleteStudent = (student) => {
    if (studentInputRef.current) studentInputRef.current.value = "";
    setStudentName("");
    let obj = {
      group_id: createGroupData?.id,
      student_id: student?.id,
    };
    GetStudentService.deleteStudentFromGroup(obj)
      .then(() => {
        setShowLoaderWhileAddingStudentIntoList(true);
        GetStudentService.getSelectedGroupData(createGroupData?.id)
          .then((data) => {
            setShowStudentContainer(false);
            setShowStudentList([]);
            setShowAddedStudentInGroup(true);
            setStudentListAfterAddedInGroup(data.data);
            setShowLoaderWhileAddingStudentIntoList(false);
            if (studentInputRef.current) studentInputRef.current.value = "";
            setStudentName("");
          })
          .catch(() => {
            setShowLoaderWhileAddingStudentIntoList(false);
          });
      })
      .catch(() => { });
  };

  useEffect(() => {
    getMaintainGroupData();
  }, []);

  useEffect(() => {
    if (!createGroupData?.name || !maintainGroupData?.result) return;
    let createdGroupIndex = maintainGroupData.result.findIndex(
      (item) => item.name === createGroupData?.name
    );
    if (createdGroupIndex >= 0) {
      setSelectedGroupIndex(createdGroupIndex);
      setSelectedGroup(maintainGroupData.result[createdGroupIndex]);
    }
  }, [createGroupData, maintainGroupData]);

  const studentList = studentListAfterAddedInGroup?.student || {};
  const isCreatingNewGroup = openCreateGroup && !openAddStudentContainer;
  const isManagingCustomGroup = openCreateGroup && openAddStudentContainer;
  const isViewingDynamicGroup =
    !openCreateGroup && selectedGroup && selectedGroup?.dynamic === true;

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="maintain-group-page">
            <div className="maintain-group-header">
              <div>
                <h1 className="maintain-group-title">Maintain Groups</h1>
                <p className="maintain-group-subtitle">
                  Create custom groups and manage student membership
                </p>
              </div>
              <button
                type="button"
                className="maintain-group-btn"
                onClick={openCreateGroupHandler}
              >
                <FontAwesomeIcon icon={faUsers} />
                Create Group
              </button>
            </div>

            <div className="maintain-group-layout">
              <div className="maintain-group-list-panel">
                <p className="maintain-group-list-title">Groups</p>
                {maintainGroupData?.result?.length > 0 ? (
                  maintainGroupData.result.map((item, index) => (
                    <div
                      key={item?.id || index}
                      onClick={() => showSelectedGroupData(item, index)}
                      className={`maintain-group-item ${index === selectedGroupIndex ? "is-active" : ""
                        }`}
                    >
                      <p className="maintain-group-item-name">{item?.name}</p>
                    </div>
                  ))
                ) : (
                  <div className="maintain-group-empty">No groups found</div>
                )}
              </div>

              <div className="maintain-group-detail-panel">
                {/* Create new group form */}
                {isCreatingNewGroup && (
                  <>
                    <div className="maintain-group-detail-header">
                      <div>
                        <h2 className="maintain-group-detail-title">
                          Create Group
                        </h2>
                        <p className="maintain-group-detail-hint">
                          Enter a name, then add students after the group is
                          created
                        </p>
                      </div>
                    </div>
                    <div className="maintain-group-field">
                      <label className="maintain-group-label" htmlFor="group-name">
                        Group Name
                      </label>
                      <input
                        id="group-name"
                        type="text"
                        className="maintain-group-input"
                        placeholder="Enter group name"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") createGroupHandler();
                        }}
                      />
                    </div>
                    <div className="maintain-group-form-actions">
                      <button
                        type="button"
                        className="maintain-group-btn"
                        disabled={creatingGroup || !(groupName || "").trim()}
                        onClick={createGroupHandler}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                        {creatingGroup ? "Creating..." : "Create Group"}
                      </button>
                      <button
                        type="button"
                        className="maintain-group-btn ghost"
                        onClick={closeCreateGroupHandler}
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                )}

                {/* Manage custom group: add/remove students */}
                {isManagingCustomGroup && (
                  <>
                    <div className="maintain-group-detail-header">
                      <div>
                        <h2 className="maintain-group-detail-title">
                          {createGroupData?.name || "Group"}
                        </h2>
                        <p className="maintain-group-detail-hint">
                          Search and add students to this group
                        </p>
                      </div>
                      {createGroupData && (
                        <button
                          type="button"
                          className="maintain-group-btn danger"
                          title="Delete group"
                          onClick={() => deleteGroup(createGroupData)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      )}
                    </div>

                    <div className="maintain-group-field">
                      <label className="maintain-group-label">Add Student</label>
                      <div className="maintain-group-search-wrap">
                        <input
                          className="maintain-group-input"
                          type="text"
                          onChange={handleStudentChange}
                          placeholder="Type a student name to add"
                          value={studentName}
                          ref={studentInputRef}
                        />
                        {showStudentContainer && showStudentList?.length > 0 && (
                          <ul className="maintain-group-student-dropdown-menu">
                            {showStudentList.map((item, index) => (
                              <li
                                key={item?.id || index}
                                onClick={() =>
                                  selectStudentFromListHandler(item)
                                }
                                className="flex maintain-group-student-list cursor"
                              >
                                {item?.current_grade != null && (
                                  <span className="dropdown-grade-background">
                                    {`${item.current_grade}th grade`}
                                  </span>
                                )}
                                <span>{item.name}</span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    {showLoaderWhileAddingStudentIntoList ? (
                      <CustomLoader />
                    ) : showAddedStudentInGroup &&
                      studentList &&
                      Object.keys(studentList).length > 0 ? (
                      <div className="maintain-group-students">
                        {Object.values(studentList).map((item, index) => (
                          <div
                            key={item?.id || index}
                            className="maintain-group-student-row"
                          >
                            <p className="maintain-group-student-name">
                              {item?.name}
                            </p>
                            <button
                              type="button"
                              className="maintain-group-btn danger"
                              title="Remove student"
                              onClick={() => deleteStudentHandler(item)}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="maintain-group-empty">
                        No students in this group yet
                      </div>
                    )}
                  </>
                )}

                {/* View dynamic group students (read-only) */}
                {isViewingDynamicGroup && (
                  <>
                    <div className="maintain-group-detail-header">
                      <div>
                        <h2 className="maintain-group-detail-title">
                          {selectedGroup?.name}
                        </h2>
                        <p className="maintain-group-detail-hint">
                          Dynamic group membership
                        </p>
                      </div>
                    </div>
                    {loading ? (
                      <CustomLoader />
                    ) : selectedGroupDataFromService?.student &&
                      Object.keys(selectedGroupDataFromService.student)
                        .length > 0 ? (
                      <div className="maintain-group-students">
                        {Object.values(
                          selectedGroupDataFromService.student
                        ).map((item, index) => (
                          <div
                            key={item?.id || index}
                            className="maintain-group-student-row"
                          >
                            <p className="maintain-group-student-name">
                              {item?.name}
                            </p>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="maintain-group-empty">
                        No students in this group
                      </div>
                    )}
                  </>
                )}

                {/* Empty state when nothing selected */}
                {!isCreatingNewGroup &&
                  !isManagingCustomGroup &&
                  !isViewingDynamicGroup && (
                    <div className="maintain-group-empty">
                      Select a group from the list, or click Create Group to
                      add a custom group
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MaintainGroup;
